/* Everhart theme behavior (Shopify port).
   The old localStorage cart is gone: Shopify owns cart state; the header
   icon links to /cart. Only presentation behaviors live here. */
(function () {
  "use strict";
  var navToggle = document.querySelector(".nav-toggle");
  var mobileNav = document.querySelector(".mobile-nav");
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
})();
